import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios'
import { toSnakeCase } from './caseConverters'

const baseURL = import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:8000/api/'

/**
 * Cliente Axios para rotas PÚBLICAS (sem auth):
 *  - Não injeta Bearer/User-ID
 *  - Não redireciona para /login em 401 (a LP pública não deve forçar logout)
 *  - Mantém conversão outgoing snake_case (consistência com a API)
 */
export const publicApi: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
  withCredentials: false,
})

publicApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (config.data && !(config.data instanceof FormData) && typeof config.data === 'object') {
    config.data = toSnakeCase(config.data)
  }
  if (config.params && typeof config.params === 'object') {
    config.params = toSnakeCase(config.params)
  }
  return config
})
